// extracted by mini-css-extract-plugin
module.exports = {"PollForm__actions":"PollForm_PollForm__actions__2sShp","PollForm__textarea":"PollForm_PollForm__textarea__TpPBZ"};